export enum ScheduleFrequencyEnum {
  NaoRepetir = 0,
  Semanalmente = 7,
  Quinzenalmente = 14,
}
